import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getAllAgeGroupSuccess } from '../../actions/CampaignMasterActions/getAllAgeGroupActions';
import { getAllAgeGroupFailure } from '../../actions/CampaignMasterActions/getAllAgeGroupActions';

function* getAllAgeGroup({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllAgeGroup,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_AGE_GROUP_SUCCESS status :", response.data.status);
        console.log("GET_ALL_AGE_GROUP_SUCCESS data :", response.data.response);
        console.log("GET_ALL_AGE_GROUP_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllAgeGroupSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_AGE_GROUP_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_AGE_GROUP_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_AGE_GROUP_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllAgeGroupFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllAgeGroupSaga() {
    yield takeLatest(actionTypes.GET_ALL_AGE_GROUP_REQUEST, getAllAgeGroup);
}

export default getAllAgeGroupSaga;